import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";
import "./style.css";
import { initAppConfig } from "./utils/clientHost";

initAppConfig().then(() => {
	createApp(App).use(router).mount("#app");
});
